import i18n from '@/i18n';
import { http } from '../helpers/axiosHelper';
export default class AnswerService {
   async getAnswer(id: Number) {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/answer/' + id).then((response) => {
         return response.data;
      });
   }

   async createAnswer(body: any) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/answer', body)
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(i18n.global.t('could_not_change_answer'));
            }
         })
         .catch((error) => {
            throw Error(i18n.global.t('could_not_change_answer'));
         });
   }

   async bulkCreateAnswers(body: any) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/answer/bulk', body)
         .then((response) => response.data)
         .catch((error) => {
            return Promise.reject(error.response?.data ?? error);
         });
   }

   async editAnswer(id: Number, body: any, submission_random: string) {
      return await http
         .patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/answer/' + id, body, {
            headers: {
               'submission-random': submission_random,
            },
         })
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(i18n.global.t('could_not_change_answer'));
            }
         })
         .catch((error) => {
            if (error?.response?.data?.errors?.content?.[0]) throw Error(error.response.data.errors.content[0]);
            else throw Error(i18n.global.t('could_not_change_answer'));
         });
   }

   async deleteAnswer(id: Number, submission_random: string) {
      return await http
         .delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/answer/' + id, { headers: { 'submission-random': submission_random } })
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(i18n.global.t('could_not_change_answer'));
            }
         })
         .catch((error) => {
            throw Error(i18n.global.t('could_not_change_answer'));
         });
   }
}
